import * as React from 'react';
import { View, Text, Modal, Pressable } from 'react-native';
import { Icon } from 'react-native-elements';
import { styles } from 'styles/components/orderDetailStatusModalMenu';
import OrderDetailStatusMenuProps from 'types/components/OrderDetailStatusModalMenuProps';
import { getTranslatedStatus } from 'types/enums/OrderStatusType';

export default ({
  visible,
  setVisible,
  statuses,
  setCheckedStatus,
  isMediumScreen,
}: OrderDetailStatusMenuProps): JSX.Element => {
  const renderModal = (): JSX.Element => {
    return (
      <View style={isMediumScreen ? styles.modalContentLarge : styles.modalContentSmall}>
        <View style={styles.closeIconContainer}>
          <Icon
            name="close"
            type="ionicon"
            color={'#001639'}
            size={30}
            onPress={() => {
              setVisible(false);
            }}
          />
        </View>
        {statuses.map((status, index) => (
          <View key={index}>
            {index === 0 ? (
              <View style={styles.statusContainer}>
                <Pressable
                  style={styles.pressableStatusContainer}
                  onPress={() => {
                    setCheckedStatus(status);
                    setVisible(false);
                  }}
                >
                  <View style={styles.outsideStatusContainer}>
                    <View style={styles.insideStatusContainer}>
                      <Text
                        style={[styles.statusText, { marginLeft: isMediumScreen ? 15 : 0 }]}
                      >{`${getTranslatedStatus(status)} ↑`}</Text>
                    </View>
                  </View>
                </Pressable>
              </View>
            ) : (
              <View style={styles.statusContainer}>
                <Pressable
                  style={styles.pressableStatusContainer}
                  onPress={() => {
                    setCheckedStatus(status);
                    setVisible(false);
                  }}
                >
                  <View style={styles.outsideStatusContainer}>
                    <View style={styles.insideStatusContainer}>
                      <Text
                        style={[styles.statusText, { marginLeft: isMediumScreen ? 15 : 0 }]}
                      >{`${getTranslatedStatus(status)} ↑`}</Text>
                    </View>
                  </View>
                </Pressable>
              </View>
            )}
          </View>
        ))}
      </View>
    );
  };

  return (
    <Modal visible={visible} transparent={true} style={styles.modal}>
      <View style={styles.container}></View>
      <View style={styles.modalBox}>{renderModal()}</View>
    </Modal>
  );
};
